import { createLayoutPortal, createLayoutPortalToken } from '@sketch/utils'

/**
 * The slot beside the canvas, in the left panel.
 *
 * The canvas is mounted once for the page, Section and frame views, so the
 * panel's frame is mounted once with it - but what goes in it belongs to the
 * view: a page selector, a Section selector, a frame selector. A portal lets
 * each view put its own navigation there without the canvas having to know
 * which views exist, the same way each one already contributes its header
 * through the layout's `HeaderPortal`.
 */
export const canvasLeftPanelToken = createLayoutPortalToken(
  'canvas-left-panel-navigation'
)

export const CanvasLeftPanelPortal = createLayoutPortal(canvasLeftPanelToken)
